import React, { Dispatch, SetStateAction } from 'react';

import MDEditor from '@uiw/react-md-editor';

import { JSONEditor } from '../../../components/json-editor';
import SwaggerUiEditor from '../../../components/json-editor/swagger-ui-editor';
import { FileState } from '../../../utils/models/common-models';


interface DataEnricherApiProps {
    selectedFile: string;
    fileStates: FileState;
    setFileStates: Dispatch<SetStateAction<FileState>>;
}

const DataEnricherApi: React.FC<DataEnricherApiProps> = ({
    selectedFile,
    fileStates,
    setFileStates,
}) => {
    return (
        <>
            {selectedFile?.endsWith(".json") && (
                <SwaggerUiEditor
                    value={fileStates[selectedFile]}
                    onChange={(value: string | undefined) => {
                        setFileStates(prevData => ({ ...prevData, [selectedFile]: value || "{}" }))
                    }}
                />
            )}

            {selectedFile.endsWith(".md") && (
                <div data-color-mode="light" style={{ height: '100%', width: '100%' }}>
                    <MDEditor
                        value={fileStates[selectedFile]}
                        onChange={(value) => setFileStates(prevData => ({ ...prevData, [selectedFile]: value }))}
                        height="100%"
                    />
                </div>
            )}

            {selectedFile === "Dockerfile" && (
                <JSONEditor
                    language="dockerfile"
                    // editorReadOnly={true}
                    isSchemaSampleDataOn={false}
                    value={fileStates[selectedFile]}
                    onChange={(value: string | undefined) => {
                        setFileStates(prevData => ({ ...prevData, [selectedFile]: value || "" }))
                    }}
                />
            )}
        </>
    )
}

export default DataEnricherApi